import { render, staticRenderFns } from "./ProProdutoModal.vue?vue&type=template&id=16cb9c86&scoped=true"
import script from "./ProProdutoModal.vue?vue&type=script&lang=js"
export * from "./ProProdutoModal.vue?vue&type=script&lang=js"
import style0 from "./ProProdutoModal.vue?vue&type=style&index=0&id=16cb9c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb9c86",
  null
  
)

export default component.exports